<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container text-center overflow-hidden pb-5">
  <div class="row justify-content-center">
    <div class="col-8 mb-3">
      <h1>
        ประวัติของฉัน
      </h1>
    </div>
  </div>
  <mat-tab-group #tabGroup (selectedTabChange)="recenter($event.index)">

    <mat-tab label="ประวัติการชำระเงิน">
      <mat-tab-group [(selectedIndex)]="selectIndex">

        <mat-tab label="รอดำเนินการ">
          <mat-card class="m-3" *ngFor="let p of waitPay">

            <!-- mobile size -->
            <mat-card-content class="d-none d-block d-sm-block d-md-none" style="padding-bottom: 10px">
              <div class="row justify-content-center">
                <div class="col text-left">
                  <h5 class=" m-3 lifedi-color">
                    {{ p.PAYMENT_NAME }}
                  </h5>
                  <p class="m-3">
                    {{ p.PAYMENT_ID }}
                  </p>
                  <p class="m-3">{{ p.PAYMENT_DATE | date }}</p>
                  <p class="m-3">
                    <span *ngIf="p.PRICE === 0">ฟรี</span>
                    <span *ngIf="p.PRICE > 0">ราคา {{ p.PRICE | number }} บาท</span>
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'W'">
                    ประเภท: กิจกรรม (workshop)
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) !== 'S'">
                    ประเภท: คอร์สเรียน
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'R'">
                    ประเภท: รายงานผล
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) === 'S'">
                    ประเภท: กิจกรรม (consult)
                  </p>
                  <div *ngIf="p.PAYMENT_STATUS ==='waiting_pay'">
                    <div *ngIf="p.STATUS === 1">
                      <p class="text-danger text-left m-3">รายการนี้ถูกลบออกจากระบบแล้ว</p>
                      <p class="text-danger text-left m-3">ไม่สามารถทำรายการได้</p>
                    </div>
                    <div *ngIf="p.STATUS === 0">
                      <mat-card class="text-center m-3" style="background: #DE5C8E; color: #fff; cursor: pointer;"
                        (click)="transfer(p.REF_ID)">
                        ชำระเงิน
                      </mat-card>
                      <mat-card class="text-center m-3 p-2 bg-secondary" style="color: #fff; cursor: pointer;"
                        (click)="cancelPayment(p.PAYMENT_ID, p.REF_ID, p.PAYMENT_NAME)">
                        ยกเลิก
                      </mat-card>

                      <div
                        *ngIf="p.REF_ID.charAt(0) === 'W' || (p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) === 'S')">
                        <p *ngIf="p.PAYMENT_STATUS ==='waiting_pay' && p.STATUS === 0" class="text-left m-3">
                          โปรดดำเนินการก่อนวันที่ {{ p.EXP_PAYDATE | dateTime: 'full' }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p *ngIf="p.PAYMENT_STATUS ==='waiting_confirm'" class="text-left m-3 font-weight-bold lifedi-color">
                อยู่ระหว่างรอการตรวจสอบ
              </p>
            </mat-card-content>

            <!-- desktop size -->
            <mat-card-content
              class="d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
              <div class="row">
                <div class="col-lg-10 col-md-8 text-left float-left">
                  <h5 class=" m-3 lifedi-color">
                    {{ p.PAYMENT_NAME }}
                  </h5>
                  <p class="m-3">
                    {{ p.PAYMENT_ID }}
                  </p>
                  <p class="m-3">
                    <span *ngIf="p.PRICE === 0">ฟรี</span>
                    <span *ngIf="p.PRICE > 0">ราคา {{ p.PRICE | number }} บาท</span>
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'W'">
                    ประเภท: กิจกรรม (workshop)
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) !== 'S'">
                    ประเภท: คอร์สเรียน
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'R'">
                    ประเภท: รายงานผล
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) === 'S'">
                    ประเภท: กิจกรรม (consult)
                  </p>
                </div>
                <div class="col-lg-2 col-md-4 float-right">
                  <p class="text-right m-3">{{ p.PAYMENT_DATE | date }}</p>
                  <div *ngIf="p.PAYMENT_STATUS ==='waiting_pay'">
                    <div *ngIf="p.STATUS === 1">
                      <p class="text-danger mr-3 mb-0 text-right">รายการนี้ถูกลบออกจากระบบแล้ว</p>
                      <p class="text-danger mr-3 text-right">ไม่สามารถทำรายการได้</p>
                    </div>
                    <div *ngIf="p.STATUS === 0">
                      <mat-card class="m-3" style="background: #DE5C8E; color: #fff; cursor: pointer;"
                        (click)="transfer(p.REF_ID)">
                        ชำระเงิน
                      </mat-card>
                      <mat-card class="m-3 p-1 bg-secondary" style="color: #fff; cursor: pointer;"
                        (click)="cancelPayment(p.PAYMENT_ID, p.REF_ID, p.PAYMENT_NAME)">
                        ยกเลิก
                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
              <p *ngIf="p.PAYMENT_STATUS ==='waiting_confirm'" class="m-3 font-weight-bold lifedi-color"
                style="position: absolute; right: 20px; bottom: 55px;">
                อยู่ระหว่างรอการตรวจสอบ
              </p>
              <div *ngIf="p.REF_ID.charAt(0) === 'W' || (p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) === 'S')">
                <p *ngIf="p.PAYMENT_STATUS ==='waiting_pay' && p.STATUS === 0" class="text-right mt-1 mr-3">
                  โปรดดำเนินการก่อนวันที่ {{ p.EXP_PAYDATE | dateTime: 'full' }}
                </p>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <mat-tab label="สำเร็จ">
          <mat-card class="m-3" *ngFor="let p of paid">

            <!-- mobile size -->
            <mat-card-content class="d-none d-block d-sm-block d-md-none" style="padding-bottom: 10px">
              <div class="row justify-content-center">
                <div class="col text-left">
                  <h5 class=" m-3 lifedi-color">
                    {{ p.PAYMENT_NAME }}
                  </h5>
                  <p class="m-3">
                    {{ p.PAYMENT_ID }}
                  </p>
                  <p class="m-3">{{ p.PAYMENT_DATE | date }}</p>
                  <p class="m-3">
                    <span *ngIf="p.PRICE === 0">ฟรี</span>
                    <span *ngIf="p.PRICE > 0">ราคา {{ p.PRICE | number }} บาท</span>
                  </p>
                  <p class="m-3" *ngIf="p.PAYMENT_TYPE.TYPE !== 'free'">
                    ประเภทการชำระเงิน: {{ p.PAYMENT_TYPE.DETAIL }}
                  </p>
                  <mat-card (click)="receipt(p.PAYMENT_ID, p.ACCOUNTING_ID)" class="text-center m-3"
                    style="background: #A90088; color: #fff; cursor: pointer;">
                    ใบเสร็จ
                  </mat-card>
                </div>
              </div>
            </mat-card-content>

            <!-- desktop size -->
            <mat-card-content
              class="d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
              <div class="row">
                <div class="col-lg-10 col-md-8 text-left float-left">
                  <h5 class=" m-3 lifedi-color">
                    {{ p.PAYMENT_NAME }}
                  </h5>
                  <p class="m-3">
                    {{ p.PAYMENT_ID }}
                  </p>
                  <p class="m-3">
                    <span *ngIf="p.PRICE === 0">ฟรี</span>
                    <span *ngIf="p.PRICE > 0">ราคา {{ p.PRICE | number }} บาท</span>
                  </p>
                  <p class="m-3" *ngIf="p.PAYMENT_TYPE.TYPE !== 'free'">
                    ประเภทการชำระเงิน: {{ p.PAYMENT_TYPE.DETAIL }}
                  </p>
                </div>
                <div class="col-lg-2 col-md-4">
                  <p class="text-right m-3">{{ p.PAYMENT_DATE | date }}</p>
                  <mat-card (click)="receipt(p.PAYMENT_ID, p.ACCOUNTING_ID)" class="float-right mb-3 mr-3"
                    style="background: #A90088; color: #fff; cursor: pointer;">
                    ใบเสร็จ
                  </mat-card>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <mat-tab label="ไม่สำเร็จ">
          <mat-card class="m-3" *ngFor="let p of reject">

            <!-- mobile size -->
            <mat-card-content class="d-none d-block d-sm-block d-md-none" style="padding-bottom: 10px">
              <div class="row justify-content-center">
                <div class="col text-left">
                  <h5 class=" m-3 lifedi-color">
                    {{ p.PAYMENT_NAME }}
                  </h5>
                  <p class="m-3">
                    {{ p.PAYMENT_ID }}
                  </p>
                  <p class="m-3">{{ p.PAYMENT_DATE | date }}</p>
                  <p class="m-3">
                    <span *ngIf="p.PRICE === 0">ฟรี</span>
                    <span *ngIf="p.PRICE > 0">ราคา {{ p.PRICE | number }} บาท</span>
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'W'">
                    ประเภท: กิจกรรม (workshop)
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) !== 'S'">
                    ประเภท: คอร์สเรียน
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'R'">
                    ประเภท: รายงานผล
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) === 'S'">
                    ประเภท: กิจกรรม (consult)
                  </p>
                  <p class="m-3"><b>หมายเหตุ:</b> {{ p.REMARK }}</p>
                  <div *ngIf="p.STATUS === 1">
                    <p class="text-danger text-left m-3">รายการนี้ถูกลบออกจากระบบแล้ว</p>
                    <p class="text-danger text-left m-3">ไม่สามารถทำรายการได้</p>
                  </div>
                  <div *ngIf="p.STATUS === 0">
                    <div *ngIf="p.REF_ID.charAt(0) ==='C' && p.REF_ID.charAt(1) === 'S' || p.REF_ID.charAt(0) ==='W'">
                      <div *ngIf="today.getTime() - p.PAYMENT_DATE.getTime() > 86400000">
                        <p class="m-3 text-danger">
                          หมดเวลาการชำระเงินแล้ว
                        </p>
                      </div>
                      <div *ngIf="today.getTime() - p.PAYMENT_DATE.getTime() < 86400000">
                        <mat-card class="text-center m-3" style="background: #DE5C8E; color: #fff; cursor: pointer;"
                          (click)="transfer(p.REF_ID)">
                          ชำระเงิน
                        </mat-card>
                        <div *ngIf="p.REF_ID.charAt(0) ==='C' && p.REF_ID.charAt(1) === 'S'">
                          <mat-card *ngIf="p.REMARK.slice(0, 29) !== 'จำนวนเงินไม่ถูกต้อง ชำระเพิ่ม'"
                            class="text-center m-3 p-2 bg-secondary" style="color: #fff; cursor: pointer;"
                            (click)="cancelPayment(p.PAYMENT_ID, p.REF_ID, p.PAYMENT_NAME)">
                            ยกเลิก
                          </mat-card>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="p.REF_ID.charAt(0) !=='C' && p.REF_ID.charAt(1) !== 'S' || p.REF_ID.charAt(0) !=='W'">
                      <mat-card class="text-center m-3" style="background: #DE5C8E; color: #fff; cursor: pointer;"
                        (click)="transfer(p.REF_ID)">
                        ชำระเงิน
                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>

            <!-- desktop size -->
            <mat-card-content
              class="d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
              <div class="row">
                <div class="col-lg-10 col-md-8 text-left float-left">
                  <h5 class=" m-3 lifedi-color">
                    {{ p.PAYMENT_NAME }}
                  </h5>
                  <p class="m-3">
                    {{ p.PAYMENT_ID }}
                  </p>
                  <p class="m-3">
                    <span *ngIf="p.PRICE === 0">ฟรี</span>
                    <span *ngIf="p.PRICE > 0">ราคา {{ p.PRICE | number }} บาท</span>
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'W'">
                    ประเภท: กิจกรรม (workshop)
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) !== 'S'">
                    ประเภท: คอร์สเรียน
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'R'">
                    ประเภท: รายงานผล
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) === 'S'">
                    ประเภท: กิจกรรม (consult)
                  </p>
                  <p class="m-3"><b>หมายเหตุ:</b> {{ p.REMARK }}</p>
                </div>
                <div class="col-lg-2 col-md-4 float-right pl-0">
                  <div *ngIf="p.STATUS === 1">
                    <p class="text-danger mr-3 mb-0 text-right">รายการนี้ถูกลบออกจากระบบแล้ว</p>
                    <p class="text-danger mr-3 text-right">ไม่สามารถทำรายการได้</p>
                  </div>
                  <div *ngIf="p.STATUS === 0">
                    <p class="text-right m-3">{{ p.PAYMENT_DATE | date }}</p>
                    <div *ngIf="p.TYPE === 'consult' || p.TYPE === 'workshop'">
                      <div *ngIf="today.getTime() - p.PAYMENT_DATE.getTime() > 86400000">
                        <p class="mr-3 text-danger text-right">
                          หมดเวลาการชำระเงินแล้ว
                        </p>
                      </div>
                      <div *ngIf="today.getTime() - p.PAYMENT_DATE.getTime() < 86400000">
                        <mat-card class="m-3" style="background: #DE5C8E; color: #fff; cursor: pointer;"
                          (click)="transfer(p.REF_ID)">
                          ชำระเงิน
                        </mat-card>
                        <div *ngIf="p.TYPE === 'consult'">
                          <mat-card *ngIf="p.REMARK.slice(0, 29) !== 'จำนวนเงินไม่ถูกต้อง ชำระเพิ่ม'"
                            class="m-3 p-1 bg-secondary" style="color: #fff; cursor: pointer;"
                            (click)="cancelPayment(p.PAYMENT_ID, p.REF_ID, p.PAYMENT_NAME)">
                            ยกเลิก
                          </mat-card>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="p.TYPE !== 'consult' && p.TYPE !== 'workshop'">
                      <mat-card class="m-3" style="background: #DE5C8E; color: #fff; cursor: pointer;"
                        (click)="transfer(p.REF_ID)">
                        ชำระเงิน
                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

        <mat-tab label="ยกเลิก">
          <mat-card class="m-3" *ngFor="let p of cancel">

            <!-- mobile size -->
            <mat-card-content class="d-none d-block d-sm-block d-md-none" style="padding-bottom: 10px">
              <div class="row justify-content-center">
                <div class="col text-left">
                  <h5 class=" m-3 lifedi-color">
                    {{ p.PAYMENT_NAME }}
                  </h5>
                  <p class="m-3">{{ p.PAYMENT_DATE | date }}</p>
                  <p class="m-3">
                    <span *ngIf="p.PRICE === 0">ฟรี</span>
                    <span *ngIf="p.PRICE > 0">ราคา {{ p.PRICE | number }} บาท</span>
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'W'">
                    ประเภท: กิจกรรม (workshop)
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) !== 'S'">
                    ประเภท: คอร์สเรียน
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'R'">
                    ประเภท: รายงานผล
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) === 'S'">
                    ประเภท: กิจกรรม (consult)
                  </p>
                  <p class="m-3 font-weight-bold text-danger">
                    ยกเลิกแล้ว
                  </p>
                </div>
              </div>
            </mat-card-content>

            <!-- desktop size -->
            <mat-card-content
              class="d-none d-xl-block d-lg-block d-md-block d-lg-none d-xl-none d-xxl-none d-xxl-block">
              <div class="row">
                <div class="col-lg-10 col-md-8 text-left float-left">
                  <h5 class=" m-3 lifedi-color">
                    {{ p.PAYMENT_NAME }}
                  </h5>
                  <p class="m-3">
                    <span *ngIf="p.PRICE === 0">ฟรี</span>
                    <span *ngIf="p.PRICE > 0">ราคา {{ p.PRICE | number }} บาท</span>
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'W'">
                    ประเภท: กิจกรรม (workshop)
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) !== 'S'">
                    ประเภท: คอร์สเรียน
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'R'">
                    ประเภท: รายงานผล
                  </p>
                  <p class="m-3" *ngIf="p.REF_ID.charAt(0) === 'C' && p.REF_ID.charAt(1) === 'S'">
                    ประเภท: กิจกรรม (consult)
                  </p>
                </div>
                <div class="col-lg-2 col-md-4">
                  <p class="text-right m-3">{{ p.PAYMENT_DATE | date }}</p>
                  <p class="m-3 font-weight-bold text-danger" style="position: absolute; right: 15px; bottom: 0px;">
                    ยกเลิกแล้ว
                  </p>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </mat-tab>

      </mat-tab-group>
    </mat-tab>

    <mat-tab label="Skill Tree">
      <div *ngIf="mySkillTree.length > 0" class="m-3">
        <div class="mt-4 mb-3">
          <lifedi-symbol-skill-tree></lifedi-symbol-skill-tree>
        </div>
        <div class="row mt-4 mb-3">
          <div *ngFor="let skilltree of mySkillTree; let i = index;" class="col-12 mt-1 mb-4">
            <h4 class="text-center">{{skilltree.TREE_NAME}}</h4>
            <lifedi-skill-tree [nodes]="skilltree?.NODES" [clusters]="skilltree?.CLUSTER_NODES"
              [links]="skilltree?.LINKS">
            </lifedi-skill-tree>
          </div>
        </div>
      </div>
      <div *ngIf="mySkillTree.length === 0">
        <h5 class="m-3">
          ยังไม่มี Skill Tree
        </h5>
      </div>
    </mat-tab>

    <mat-tab label="แบบทดสอบ">
      <div *ngIf="measureHistory.length > 0">
        <div *ngFor="let m of measureHistory">
          <mat-card class="m-3">
            <!-- <mat-card (click)="openMeasure(m.LINK)" class="m-3" style="cursor: pointer;"> -->
            <mat-card-content>
              <div class="row">
                <div class="col-12">
                  <h5 class="text-left mt-3 mx-3">
                    {{ m.MEASURE_ID }}: {{ m.MEASURE_NAME }}
                  </h5>
                </div>
              </div>
            </mat-card-content>
            <mat-card-footer style="position: absolute; right: 50px; bottom: 30px;">
              {{ m.MEASURE_DONE }} ครั้ง | ล่าสุด {{ m.LAST_DONE | date }}
            </mat-card-footer>
          </mat-card>
        </div>
      </div>
      <div *ngIf="measureHistory.length === 0">
        <h5 class="m-3">
          ยังไม่ทำแบบทดสอบ
        </h5>
      </div>
    </mat-tab>

    <mat-tab label="งานวิจัยที่เข้าร่วม">
      <div *ngIf="researchHistory.length > 0">
        <div *ngFor="let r of researchHistory">
          <mat-card class="m-3" (click)="openResearch(r.RESEARCH_ID)" style="cursor: pointer;">
            <mat-card-content>
              <div class="row">
                <div class="col-12">
                  <h5 class="text-left m-3">
                    <!-- {{ r.RESEARCH_ID }}: {{ r.RESEARCH_NAME }} -->
                    <span *ngIf="r.PROGRESS.done % r.PROGRESS.sum_measureOfResearch === 0">
                      {{ r.RESEARCH_NAME }} ({{ (r.PROGRESS.done / r.PROGRESS.sum_measureOfResearch) * 100 | number }}%)
                    </span>
                    <span *ngIf="r.PROGRESS.done % r.PROGRESS.sum_measureOfResearch !== 0">
                      {{ r.RESEARCH_NAME }}
                      ({{ (r.PROGRESS.done / r.PROGRESS.sum_measureOfResearch) * 100 | number:'1.1-1' }}%)
                    </span>
                  </h5>
                </div>
              </div>
            </mat-card-content>
            <mat-card-footer style="position: absolute; right: 50px; bottom: 30px;">
              {{ r.PROGRESS.phase }} WAVE | {{ r.PROGRESS.sum_measureOfResearch }} แบบทดสอบ
            </mat-card-footer>
          </mat-card>
        </div>
      </div>
      <div *ngIf="researchHistory.length === 0">
        <h5 class="m-3">
          ยังไม่เข้าร่วมงานวิจัย
        </h5>
      </div>
    </mat-tab>

  </mat-tab-group>

  <div *ngIf="isLoading">
    <div
      style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
  </div>

</div>

<div *ngIf="isPrint">
  <lifedi-payment-receipt [receiptDetail]="receiptDetail" [accountId]="accountId" [isCopy]="true"></lifedi-payment-receipt>
</div>